// extracted by mini-css-extract-plugin
export var actions = "_u4-4";
export var item = "_u4-1";
export var price = "_u4-3";
export var quantity = "_u4-2";
export var table = "_u4-0";